/**
 * The intake invitation sent to a client the advisor already has.
 *
 * Kept apart from the store so the one thing that must not regress can be tested on its own: the
 * link carries the client's own survey id. With the form provider off, that id is all that ties a
 * finished form back to the client. A general advisor link, which this used to send, makes a
 * second client on submission, the very outcome choosing "send to the existing client" is for.
 *
 * The advisor's invite settings (share results, relationship stage, referral source, CRM contact)
 * travel with it, exactly as they do for a new client.
 */

import { getIntroIntakeFormApiEndPoint } from '@shared';

interface ExistingClientInviteSettings {
  emailBody: string;
  shareResults: 'yes' | 'no';
  clientRelationship?: ClientRelationshipStage;
  referralSource?: string;
  redtailContactId?: string;
  wealthboxContactId?: string;
}

export function buildExistingClientInvite(
  client: Client,
  advisorId: string,
  email: string,
  settings: ExistingClientInviteSettings,
): IntakeFormEmailProps {
  const shareResults = settings.shareResults === 'yes';
  const surveyId = client.surveyId || undefined;

  return {
    clientId: client.clientId,
    createNewClient: false,
    advisorId,
    email,
    clientFirstName: client.clientFirstName,
    clientLastName: client.clientLastName,
    advisorProvidedBody: settings.emailBody,
    surveyId,
    intakeFormLink: getIntroIntakeFormApiEndPoint(
      advisorId,
      shareResults,
      surveyId,
      undefined,
      settings.redtailContactId,
      settings.wealthboxContactId,
    ),
    clientRelationshipStage: settings.clientRelationship,
    referralSourceId: settings.referralSource,
    redtailContactId: settings.redtailContactId,
    wealthboxContactId: settings.wealthboxContactId,
    hasAccessToResults: shareResults,
  };
}
